<template>
  <div>
    <div class="text-right">
      <LoadingButton
        title="Обновить задачи"
        :loading="loading"
        :color="$constants.PRIMARY_COLOR"
        :onClick="() => getRecords()"
        className="btn btn-outline-info"
      />
    </div>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    <template v-if="!loading && records.length">
      <table class="table mt-0 table-sm table-hover">
        <thead>
        <tr>
          <th></th>
          <th>Карты</th>
          <th>SMS</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(r,i) in records">
          <tr>
            <td :rowspan="r.task_data.length + 1">
              <p>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</p>
              <p>{{ printDate(r.created_at) }}</p>
            </td>
          </tr>
          <tr v-for="c in r.task_data">
            <td><span class="badge badge-dark">{{ types[c.use_type_id] }}</span> {{ c.number }} ({{ c.slot }})</td>
            <td>
              <template v-if="!c.sms_report_id">
                <i class="icon-fa icon-fa-clock-o"/>
              </template>
              <template v-else>
                <strong>{{ c.amount }}</strong>
              </template>
            </td>
            <td></td>
          </tr>
        </template>
        </tbody>
      </table>
      <div class="text-right">
        <paginate v-if="paginator"
                  :page-count="paginator.last_page"
                  :page-range="3"
                  :margin-pages="2"
                  :click-handler="getRecords"
                  :prev-text="'&laquo'"
                  :next-text="'&raquo'"
                  :container-class="'pagination'"
                  :prev-class="'page-item'"
                  :prev-link-class="'page-link'"
                  :page-class="'page-item'"
                  :page-link-class="'page-link'"
                  :next-class="'page-item'"
                  :next-link-class="'page-link'"
                  :active-class="'active green_btn'">
        </paginate>
      </div>
    </template>
  </div>
</template>

<script>

import api from "@/api";
import Paginate from 'vuejs-paginate'
import LoadingButton from "@/components/buttons/LoadingButton.vue";

export default {
  components: {
    Paginate,
    LoadingButton,
  },
  data() {
    return {
      loading: false,
      paginator: null,
      types: {
        1: 'почта',
        2: 'доставка',
        3: 'регионы',
      },
      records: [],
    }
  },
  mounted() {
    this.getRecords();
  },
  methods: {
    async getRecords(page = 1) {
      this.loading = true;
      const {data: r_data} = await api.index('/tasks/type/15?page=' + page);
      if (r_data.success) {
        const {data, ...pagination} = r_data.records;
        this.paginator = pagination;
        this.records = data;
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
table.table td {
  padding: 3px;
}
</style>
